import { render } from "./productFlags.vue?vue&type=template&id=a9328ada"
import script from "./productFlags.vue?vue&type=script&lang=js"
export * from "./productFlags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__